import { gql } from "apollo-boost";

export const CREATE_ARTICLE = (name, is_prototype, date, id_article_type) => {
  return gql`
  mutation CREATE_ARTICLE {
    createArticle(
      name: ${name}
      description: ${name}
      is_prototype: ${is_prototype}
      date: ${date}
      id_article_type: ${id_article_type}
    ) 
  }
`;
};

export const CREATE_ARTICLE_ = gql`
  mutation CREATE_ARTICLE($name: String!, $is_prototype: Boolean!, $date: DateTime!, $id_article_type: Int!, $id_entity: Int!) {
    createArticle(
      name: $name
      description: $name
      is_prototype: $is_prototype
      date: $date
      id_article_type: $id_article_type
      id_entity: $id_entity
    )
  }
`;

export const UPDATE_ARTICLE = gql`
  mutation UPDATE_ARTICLE($id_article: Int!, $name: String!, $is_prototype: Boolean!) {
    updateArticle(id_article: $id_article, name: $name, is_prototype: $is_prototype)
  }
`;

export const DELETE_ARTICLE = gql`
  mutation DELETE_ARTICLE($id_article: Int!, $id_entity: Int!) {
    deleteArticle(id_article: $id_article, id_entity: $id_entity)
  }
`;

export const CREATE_ARTICLE_ENTITY = (id_entity, id_article) => gql`
  mutation CREATE_ARTICLE_ENTITY {
    createArticleEntity(
      id_entity: ${id_entity}
      id_article: ${id_article}
    ) 
  }
`;
export const CREATE_ARTICLE_ENTITY_ = gql`
  mutation CREATE_ARTICLE_ENTITY($id_entity: Int!, $id_article: Int!) {
    createArticleEntity(id_entity: $id_entity, id_article: $id_article)
  }
`;
export const DELETE_ARTICLE_ENTITY = gql`
  mutation DELETE_ARTICLE_ENTITY($id_entity: Int!, $id_article: Int!) {
    deleteArticleEntity(id_entity: $id_entity, id_article: $id_article)
  }
`;

export const CREATE_ARTICLE_PROP_VALUE = (id_article, tag, value) => gql`
  mutation CREATE_ARTICLE_PROP_VALUE {
    createArticlePropertyValue(
      id_article: ${id_article}
      tag: ${tag}
      value: ${value}
    ) 
  }
`;

export const CREATE_ARTICLE_PROP_VALUE_ = gql`
  mutation CREATE_ARTICLE_PROP_VALUE($id_article: Int!, $tag: String!, $value: String!) {
    createArticlePropertyValue(id_article: $id_article, tag: $tag, value: $value)
  }
`;

export const UPDATE_ARTICLE_PROP_VALUE = gql`
  mutation UPDATE_ARTICLE_PROP_VALUE($id_article: Int!, $tag: String!, $value: String!) {
    updateArticlePropertyValue(id_article: $id_article, tag: $tag, value: $value)
  }
`;

export const DELETE_ARTICLE_PROP_VALUE = gql`
  mutation DELETE_ARTICLE_PROP_VALUE($id_article: Int!, $tag: String!) {
    deleteArticlePropertyValue(id_article: $id_article, tag: $tag)
  }
`;
